import React from 'react';
import LeftPanel from './LeftPannel';

interface LayoutProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className='h-screen w-screen flex'>
            <LeftPanel/>
            <main className="layout-content flex-grow overflow-auto h-screen">
                {children}
            </main>
           
        </div>
    );
};

export default Layout;